module.exports = __webpack_public_path__ + "img/game.830f2d5f.svg";